let apiURL = process.env.NODE_ENV === 'development' ? 'http://dev.orange.fr:8080/' : 'https://www.orange.fr/'

const exceptions = [
   {
      rules: ['staging.orange.fr', 'www.preprod.orange.fr', 'cachee.hbx.geo.francetelecom.fr'],
      domain: window.location.origin + '/',
   },

    //TODO voir si on garde ca comme ca ou pas!
   // Local dev : rediriger les appels API vers le backend local (localhost, 127.0.0.1)
   {
      rules: ['localhost', '127.0.0.1'],
      domain: window.location.origin + '/',
   },
   {
      rules: [
         'elcos-sosh-staging-priv.sg0.liveservices.fr',
         'elcos-sosh-pcache-priv.sg0.liveservices.fr',
         'elcos-sosh-dev-priv.sg0.liveservices.fr',
         "hporange-dev-priv.0a7.liveservices.fr",
         "hporange-staging-priv.0a7.liveservices.fr",
         "hporange-pcache-priv.0a7.liveservices.fr",
         "*.0a7.staging.orange.fr",
         "www-dev.sso-ints.orange.fr",
         "www-staging.sso-ints.orange.fr",
         "www-pcache.sso-ints.orange.fr",
         "www.pcache.orange.fr"
      ],
      domain: window.location.origin + '/',
   }
]

export const getApiUrl = (profile, context) => {
   const pageName = getPageName(profile)
   let queryString = window.location.search
   if (context) {
      queryString = queryString ? `${queryString}&context=${context}` : `?context=${context}`
   }

   //    Gestion des exceptions de domaine en production
   exceptions.forEach((exception) => {
      exception.rules.forEach((rule) => {
         // Si le hostname correspond à une règle, on utilise le domaine d'exception
         if (window.location.hostname.indexOf(rule) !== -1) {
            apiURL = exception.domain
         }
      })
   })

   return apiURL + pageName + queryString
}

const getPageName = (profile) => {
   const paths = {
      hp: 'api/events/accueils/portail',
      tv: 'api/events/accueils/tv',
      boutique: 'api/events/accueils/boutique',
      shop: 'api/events/shop/vitrine_mobile_forfait',
      boutique_confirmation_commande: 'api/events/shop/confirmation_commande',
      preview: 'api/events/accueils/preview',
   }
   return paths[profile]
}
